import { BusinessCard } from '../types/BusinessCard';

/** Public demo card: shown in the landing hero and at /card/demo (no API needed). */
export const demoCard: BusinessCard = {
  id: 'demo',
  name: 'Sara Johnson',
  title: 'Chief Innovation Officer',
  company: 'Oz Systems Pty Ltd',
  email: 'sara@obusinesscard.com',
  phone: '+61 4 1234 5678',
  website: 'https://obusinesscard.com',
  linkedin: 'linkedin.com/in/sarajohnson',
  twitter: '@sarajohnson',
  address: '42 Innovation Drive, Sydney NSW 2000',
  profileImage: '/images/sara.png',
  backgroundColor: 'linear-gradient(135deg, #374151 0%, #1F2937 100%)',
  textColor: '#ffffff',
  createdAt: new Date(),
  updatedAt: new Date(),
  isPremium: true,
  customization: {
    companyStyle: {
      startAngle: -90,
      radius: 175,
      color: '#3B82F6',
      fontFamily: '"General Sans", sans-serif',
      fontSize: 19,
      fontWeight: 700,
      maxArcDegrees: 160,
    },
    centerNameStyle: {
      startAngle: -90,
      radius: 150,
      color: '#ffffff',
      fontSize: 24,
      fontFamily: '"General Sans", sans-serif',
      fontWeight: 800,
      maxArcDegrees: 150,
    },
    centerStyle: {
      profileCircleSize: 180,
      showBranding: true,
      nameCurved: true,
      centerOffset: { x: 0, y: 0 },
      nameHorizontalOffset: 0,
      nameVerticalOffset: 0,
    },
    contactStyle: {
      color: '#D1D5DB',
      fontSize: 14,
      fontFamily: '"Inter", sans-serif',
      fontWeight: 400,
      radius: 175,
      startAngle: 90,
      maxArcDegrees: 160,
    },
  },
};

export const DEMO_CARD_ID = 'demo';
